module.exports = __webpack_public_path__ + "static/media/gallery23.cf76caf9.png";